module.exports = __webpack_public_path__ + "static/img/pc_bg.ea2fe40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/pc_bg.png
// module id = kaub
// module chunks = 1